<template>
  <div id="basketball_scheduleDetail_analysis">
    <MoreThemeList
      v-if="findAnalysisItemParams"
      :axiosBaseUrl="axiosBaseUrl"
      :currThemeObj="currThemeObj"
      :currCid="currCid"
      :currSid="currSid"
      :isRefresh="isRefresh"
      :refreshTime="refreshTime"
      :findAnalysisItemParams="findAnalysisItemParams"
      :curTimeZoneItem="curTimeZoneItem"
    ></MoreThemeList>
  </div>
</template>

<script>
import MoreThemeList from '@components/base/theme/more_themeList.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'basketball_scheduleDetail_analysis',
  mixins: [cup_base_data_mixin],
  components: {
    MoreThemeList,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    isRefresh: {
      type: Boolean,
      default: false,
    },
    refreshTime: {
      type: Number,
      default: 15 * 1000, //刷新时间 单位毫秒
    },
  },
  watch: {
    currSportsDetail: {
      handler(newVal, oldVal) {
        console.debug('重新刷新数据 currSportsDetail:', newVal, oldVal)
        if (
          JSON.stringify(newVal) != JSON.stringify(oldVal) &&
          newVal.matchId
        ) {
          this.init()
        }
      },
      // immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      // 以下三个是主题固定参数（前2个必有，paramsChangeObj可选）
      themeTemplateType: 24,
      findAnalysisItemParams: null,
    }
  },
  created() {
    this.init()
  },
  mounted() {},
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      const query = this.$route.query
      this.cid = query.cid
      this.sid = query.sid
      this.mid = query.mid
      this.makeAnalysisItemParams(this.themeTemplateType)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      // 因为只有比赛，所以 https_package_selectApi 不需要传did,eid,pid这些
      this.findAnalysisItemParams = {
        sportType: 'basketball',
        templateType: themeTemplateType,
        cid: this.cid,
        sid: this.sid,
        did: 0,
        eid: 0,
        pid: 0,
        mid: this.mid ? this.mid : 0,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#basketball_scheduleDetail_analysis {
  width: 100%;
  height: auto;
}

</style>
